import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ApprovedProjectWidget from '../../../widgets/adminReport/approvedProject/ApprovedProjectWidget'
import { getProjectalreadyapprovelist } from '../../../redux/actions/adminReport'

export default function PreApprovedProject(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectalreadyapprovelist()

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <ApprovedProjectWidget schema={schema.form.searchObject} />
    </SidebarProposal>
  )
}
